import { render, staticRenderFns } from "./BigArmyLoading.vue?vue&type=template&id=126d2f17&scoped=true"
import script from "./BigArmyLoading.vue?vue&type=script&lang=js"
export * from "./BigArmyLoading.vue?vue&type=script&lang=js"
import style0 from "./BigArmyLoading.vue?vue&type=style&index=0&id=126d2f17&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d2f17",
  null
  
)

export default component.exports